export default __webpack_public_path__ + "4c143a63197f2eecbeb87eeef3c7af0e.webp";